export const initialState = {
  transactions: [],
  transaction: {},
  nextTokens: { 1: null },
  error: null,
  loading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        transactions: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        error: null,
        loading: true,
      };
    case "LIST_TRANSACTION_SUCCESS":
      return {
        ...state,
        request: null,
        transactions: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
      };
    case "LIST_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.error,
      };
    case "REQUEST_GET_TRANSACTION":
      return {
        ...state,
        transaction: {},
        error: null,
        loading: true,
      };
    case "REQUEST_REFRESH_TRANSACTION":
      return {
        ...state,
        error: null,
      };
    case "REFRESH_TRANSACTION_ERROR":
      return {
        ...state,
        loading: false,
      };
    case "GET_TRANSACTION_SUCCESS":
      return {
        ...state,
        transaction: action.payload.transaction,
        loading: false,
      };
    case "GET_TRANSACTION_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
